module.exports = __webpack_public_path__ + "img/right.fcca5b4e.svg";